import { createSelector } from 'reselect'

import { selectPartner360Data } from './selectPartner360Data'

export const selectSalesTypeOptions = createSelector(
  [selectPartner360Data],
  (configuration) => configuration.salesTypes
)
